import { render, staticRenderFns } from "./ServerClock.vue?vue&type=template&id=06b87eb6&scoped=true"
import script from "./ServerClock.vue?vue&type=script&lang=js"
export * from "./ServerClock.vue?vue&type=script&lang=js"
import style0 from "./ServerClock.vue?vue&type=style&index=0&id=06b87eb6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b87eb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06b87eb6')) {
      api.createRecord('06b87eb6', component.options)
    } else {
      api.reload('06b87eb6', component.options)
    }
    module.hot.accept("./ServerClock.vue?vue&type=template&id=06b87eb6&scoped=true", function () {
      api.rerender('06b87eb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/clock/ServerClock.vue"
export default component.exports